module.exports = __webpack_public_path__ + "img/ok.fc8f71a4.png";